import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { useChosenLevel } from '../../hooks/useChosenLevel.js';

export const useMediaPlanSummaryApi = ({ enabled = true } = {}) => {
  const { id: mediaDataId } = useChosenLevel();

  return useQuery({
    ...MediaPlan.getMediaPlanSummaryQueryOptions({
      urlParams: {
        mediaDataId: mediaDataId ?? '',
      },
    }),
    enabled: enabled && !!mediaDataId,
  });
};
